'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver from "./com.raquo.airstream.common.-Internal-Try-Observer.js";
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dStream from "./com.raquo.airstream.common.-Single-Parent-Stream.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream from "./com.raquo.airstream.core.-Writable-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_distinct_DistinctStream(parent, isSame, resetOnStop) {
  this.DX = null;
  this.DV = false;
  this.DY = null;
  this.DT = null;
  this.DU = null;
  this.E1 = false;
  this.ys = null;
  this.DW = null;
  this.DZ = false;
  this.E0 = 0;
  this.uM = null;
  this.ys = parent;
  this.DW = isSame;
  this.DZ = resetOnStop;
  this.DX = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.E0 = ((1 + parent.dT()) | 0);
  this.uM = (void 0);
}
export { $c_Lcom_raquo_airstream_distinct_DistinctStream as $c_Lcom_raquo_airstream_distinct_DistinctStream };
$p = $c_Lcom_raquo_airstream_distinct_DistinctStream.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_distinct_DistinctStream;
/** @constructor */
function $h_Lcom_raquo_airstream_distinct_DistinctStream() {
}
export { $h_Lcom_raquo_airstream_distinct_DistinctStream as $h_Lcom_raquo_airstream_distinct_DistinctStream };
$h_Lcom_raquo_airstream_distinct_DistinctStream.prototype = $p;
$p.dP = (function() {
  return this.DX;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.DV;
});
$p.fm = (function() {
  return this.DY;
});
$p.ea = (function(x$1) {
  this.DV = x$1;
});
$p.gD = (function(x$1) {
  this.DY = x$1;
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.hm = (function(observer) {
});
$p.ew = (function() {
  return this.DT;
});
$p.ey = (function() {
  return this.DU;
});
$p.hw = (function() {
  return this.E1;
});
$p.g1 = (function(x$1) {
  this.E1 = x$1;
});
$p.hf = (function(x$0) {
  this.DT = x$0;
});
$p.hg = (function(x$0) {
  this.DU = x$0;
});
$p.hp = (function() {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.ys);
});
$p.hn = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dStream.$f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.fW = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.fV = (function(nextError, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.dT = (function() {
  return this.E0;
});
$p.fX = (function(nextValue, transaction) {
  var x = this.uM;
  var x$1 = ((x === (void 0)) ? (void 0) : (!(!(!this.DW.bB(x, nextValue)))));
  var isDistinct = ((x$1 === (void 0)) || x$1);
  this.uM = nextValue;
  if (isDistinct) {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
  }
});
$p.ho = (function() {
  if (this.DZ) {
    this.uM = (void 0);
  }
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dStream.$f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.eB = (function() {
  return this.ys;
});
$p.hi = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_distinct_DistinctStream = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_distinct_DistinctStream, "com.raquo.airstream.distinct.DistinctStream", ({
  gV: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  ba: 1,
  bm: 1,
  as: 1,
  bI: 1,
  aj: 1,
  c1: 1,
  ay: 1
}));
export { $d_Lcom_raquo_airstream_distinct_DistinctStream as $d_Lcom_raquo_airstream_distinct_DistinctStream };
